import CONSTANTS from '../constants';
import { createAction } from 'redux-actions';

export const showMessage = createAction(CONSTANTS.SHOW_MESSAGE);
export const hideMessage = createAction(CONSTANTS.HIDE_MESSAGE);
